<template>
  <content-box class="plan-subscription--wrap"
               :width="'1018px'"
               :height="'734px'">
    <p class="title">
      <template v-if="planData.canCreate">{{ $t('common.planSubscription') }}</template>
      <template v-else>{{ $t('common.changePlan') }}</template>
    </p>
    <p class="desc">{{ $t('userInfo.managePlan.planSubscription.desc') }}</p>
    <div class="scrollable">
      <div class="payment-type--wrap">
        <div class="payment-type">
          <button type="button"
                  class="left"
                  :class="{on: paymentType === 'card'}"
                  @click="onSelectPaymentType('card')">
            <i class="icon icon--check-white-size20"></i>{{ $t('userInfo.managePlan.planSubscription.button.card') }}
          </button>
          <button type="button"
                  class="right"
                  :class="{on: paymentType === 'wireTransfer'}"
                  @click="onSelectPaymentType('wireTransfer')">
            <i class="icon icon--check-white-size20"></i>{{ $t('userInfo.managePlan.planSubscription.button.wire') }}
          </button>
        </div>
        <span class="vat">{{ $t('common.noVat') }}</span>
      </div>
      <div class="step__content table--wrap">
        <table>
          <colgroup>
            <col width="*">
            <col width="160">
            <col width="160">
            <col width="160">
            <col width="160">
          </colgroup>
          <thead>
          <tr class="thead-row real">
            <th></th>
            <th class="first" :class="[`row__${item.name}`, {ie: browser.isIE}]" v-for="item in normalPlans" :key="item.name">
              <p class="plan">{{ item.name | upperFirst }}</p>
              <p class="price">₩ {{ item.price | thousand }}</p>
            </th>
            <th class="first row__enterprise" :class="{ie: browser.isIE}">
              <p class="plan">{{ $t('common.table.header.enterprise') }}</p>
              <p class="price">{{ $t('common.table.header.contactUs') }}</p>
            </th>
          </tr>
          </thead>
          <tfoot>
          <tr>
            <td></td>
            <td v-for="item in normalPlans" :key="item.name">
              <ui-button
                :primary2="true"
                :disabled="!canChangePlan(item.planNumber)"
                @mouseenter.native="onMouseEnter(item.name)"
                @mouseleave.native="onMouseLeave"
                @click="onSelectPlan(item.planNumber)">
                <template v-if="paymentType === 'card'">
                  <template v-if="isInUsePlan(item.planNumber)">
                    {{ $t('common.inUse') }}
                  </template>
                  <template v-else>{{ $t('common.select') }}</template>
                </template>
                <template v-else>{{ $t('common.contactUs') }}</template>
              </ui-button>
            </td>
            <td>
              <ui-button
                :primary2="true"
                @mouseenter.native="onMouseEnter(null, true)"
                @mouseleave.native="onMouseLeave"
                @click="onSelectPlan('enterprise', true)">{{ $t('common.contactUs') }}</ui-button>
            </td>
          </tr>
          </tfoot>
          <tbody>
          <tr v-for="(optionItem, optionIndex) in normalPlanOptionList" :key="optionIndex">
            <td scope="row" v-html="$t(`userInfo.managePlan.planSubscription.table.row.${optionItem.name}`)"></td>
            <td v-for="(planItem, planIndex) in normalPlans" :key="planIndex"
                @mouseenter="onMouseEnter(planItem.name)"
                @mouseleave="onMouseLeave"
                @click="onSelectPlan(planItem.planNumber)"
                :class="[`row__${planItem.name}`, {last: optionIndex === 16}, {ie: browser.isIE}]"><!-- 16 : optionsPerPlan.length -->
              <div v-if="typeof optionItem.value[planItem.planNumber] !== 'boolean'">
                {{ optionItem.name === 'pv'? Number(optionItem.value[planItem.planNumber]).toLocaleString('en') : optionItem.value[planItem.planNumber] }}
                <span class="unit" v-if="optionItem.name === 'pv'"> {{ $t('common.unit.pv') }}</span>
                <span class="unit" v-else-if="optionItem.name === 'dataReflection'"> {{ $tc('common.unit.hour', 1) }}</span>
                <span class="unit" v-else-if="optionItem.name === 'dataStoragePeriod'"> {{ $tc('common.unit.month', 6) }}</span>
              </div>
              <div v-else-if="typeof optionItem.value[planItem.planNumber] === 'boolean' && optionItem.value[planItem.planNumber]"><i class="icon icon--check-green-size20"></i></div>
              <div v-else></div>
            </td>
            <td v-if="optionIndex === 0"
                rowspan="17"
                class="row__enterprise last"
                :class="{ie: browser.isIE}"
                @mouseenter="onMouseEnter(null, true)"
                @mouseleave="onMouseLeave"
                @click="onSelectPlan('enterprise')"
                v-html="$t('userInfo.managePlan.planSubscription.table.enterprise')">
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <i class="icon icon--close-size16" @click="onCloseLayer"></i>
  </content-box>
</template>

<script>
import { openContactUs } from '@/libs/utils'
import { normalPlans, normalPlanOptionList } from '@/libs/plan-helper'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import browser from '@/libs/browser'

export default {
  components: {
    ContentBox,
    UiButton
  },
  props: [
    'userData',
    'planData'
  ],
  data () {
    return {
      paymentType: 'card',
      browser: browser
    }
  },
  created () {
    this.normalPlans = normalPlans
    this.normalPlanOptionList = normalPlanOptionList
  },
  methods: {
    onSelectPaymentType (value) {
      this.paymentType = value
    },
    canChangePlan (planNumber) {
      if (this.planData.isTrial || this.planData.useCoupon) {
        return true
      } else {
        return planNumber !== this.planData.servicePlanNumber
      }
    },
    isInUsePlan (planNumber) {
      if (this.planData.isTrial || this.planData.useCoupon) {
        return false
      } else {
        return planNumber === this.planData.servicePlanNumber
      }
    },
    onSelectPlan (value) {
      if (value === 'enterprise' || this.paymentType !== 'card') {
        openContactUs(this.userData.userNum)
        this.onCloseLayer()
        return false
      }

      if (this.canChangePlan(value)) {
        this.$emit('onPlanNumberChange', {
          paymentType: this.paymentType,
          planNumber: value
        })
      }
    },
    onMouseEnter (value, enterprise) {
      let targetElements
      if (enterprise) {
        targetElements = document.querySelectorAll('.row__enterprise')
      } else {
        targetElements = document.querySelectorAll(`.row__${value}`)
      }
      for (let i = 0; i < targetElements.length; i++) {
        targetElements[i].classList.add('hover')
      }
    },
    onMouseLeave () {
      let targetElements = document.querySelectorAll('[class*=row__]')
      for (let i = 0; i < targetElements.length; i++) {
        targetElements[i].classList.remove('hover')
      }
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.plan-subscription--wrap {
  padding: 30px;
  box-sizing: border-box;

  .icon--close-size16 {
    position: absolute;
    padding: 12px;
    top: 0px;
    right: 0px;
    background-position: center;
    border-radius: 100px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #444444;
  }
  .desc {
    font-size: 13px;
    color: #444444;
    margin-top: 12px;
    margin-bottom: 25px;
  }
  .scrollable {
    height: 600px;
    overflow-y: scroll;
  }
  .payment-type--wrap {
    @include flexXbetween;
    align-items: center;

    .payment-type {
      display: inline-block;
      vertical-align: middle;
      height: 38px;
      border-radius: 20px;
      box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.04);
      border: solid 1px #e0e0e0;
      background-color: #ffffff;

      &> button {
        text-align: left;
        display: inline-block;
        box-sizing: border-box;
        height: 100%;
        line-height: 38px;
        padding: 0 12px;
        background-color: transparent;
        cursor: pointer;
        min-width: 220px;
        font-size: 15px;
        font-weight: bold;
        color: #888888;
      }

      .icon {
        vertical-align: top;
        margin-top: 8px;
        margin-right: 22px;
      }

      .on {
        border-radius: 20px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
        background-color: $brandColor;
        cursor: default;
        color: #ffffff;
        position: relative;
        top: -1px;
        min-width: 221px;
        height: 40px;
      }

      .left.on {
        margin-right: -12px;
        left: -1px;
      }
      .right.on {
        margin-left: -12px;
        right: -1px;
      }
    }
    .vat {
      font-size: 13px;
      line-height: 1;
      color: #ec0047;
    }
  }
  .table--wrap {
    width: 100%;
    background-color: #fff;
    margin-top: 15px;

    table {
      width: 100%;
      table-layout: fixed;
      font-size: 14px;
      color: #444444;
      thead {
        tr {
          height: 85px;

          .plan {
            font-size: 16px;
            font-weight: bold;
            color: #444444;
          }
          .price {
            margin-top: 9px;
            font-size: 22px;
            font-weight: bold;
            color: #ec0047;
          }
        }
      }
      tbody {
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        tr {
          height: 35px;
          border-bottom: 1px solid #d7d7d7;

          &:nth-last-child(1) {
            border-bottom: 0;
          }

          td {
            box-sizing: border-box;
            text-align: center;

            &[scope='row'] {
              text-align: left;
              padding-left: 10px;
              line-height: 1.2;
            }

            &:nth-child(2n) {
              background-color: #f4f4f4;
            }

            &.row__enterprise {
              padding: 0 15px;
              line-height: 1.46;
            }
          }
        }
      }
      tfoot {
        td {
          padding-top: 15px;
          text-align: center;
        }
      }
      [class*=row__].hover {
        position: relative;
        box-sizing: border-box;
        &::after {
          box-sizing: border-box;
          content: '';
          display: inline-block;
          width: 100%;
          height: calc(100% + 2px); // cover table lines
          border-left: 2px solid red;
          border-right: 2px solid red;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }
        &:nth-child(2n)::after {
          top: -1px;
          border-bottom: 0.5px solid #d7d7d7;
        }
        &.first:after {
          height: calc(100% + 2px); // cover table lines
          border-bottom: 0;
          border-top: 2px solid red;
        }
        &.last:after {
          border-bottom: 2px solid red;
        }
      }
      .row__enterprise.hover {
        &::after {
          height: calc(100% + 2px); // adjust highlight height
        }
      }
      [class*=row__].ie.hover {
        &::after {
          height: 36px;
          z-index: 1;
        }
        &.first:after {
          height: 86px;
          z-index: 1;
        }
      }
      .row__enterprise.ie.hover {
        &.last {
          border-bottom: 1px solid red;
          overflow: hidden;
        }
        &.last:after {
          height: 595px;
        }
      }
    }
  }
}
</style>
